import {useState} from 'react';

/**
 * アラート設定フォームの状態管理フック
 * フォームフィールドの状態とセッターを提供
 */
export const useAlertSettingsForm = () => {
  // 基本設定
  const [alertName, setAlertName] = useState<string>('');
  const [active, setActive] = useState<boolean>(true);
  const [machine, setMachine] = useState<string>('');
  const [rule, setRule] = useState<string>('1');
  const [processType, setProcessType] = useState<string>('1');

  // スケジュール設定
  const [scheduleType, setScheduleType] = useState<string>('1'); // '1': 定期, '2': 固定
  const [days, setDays] = useState<string[]>(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']);

  // 定期スケジュール用
  const [from, setFrom] = useState<string>('08:00');
  const [to, setTo] = useState<string>('22:00');
  const [interval, setInterval] = useState<string>('1');

  // 固定スケジュール用
  const [fixTime, setFixTime] = useState<string>('08:00');

  // PDFレポート設定
  const [isPdf, setIsPdf] = useState<boolean>(false);

  /**
   * 全フィールドをリセット
   */
  const resetForm = () => {
    setAlertName('');
    setActive(true);
    setMachine('');
    setRule('1');
    setProcessType('1');
    setScheduleType('1');
    setDays(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']);
    setFrom('08:00');
    setTo('22:00');
    setInterval('1');
    setFixTime('09:00');
    setIsPdf(false);
  };

  return {
    // 基本設定
    alertName,
    setAlertName,
    active,
    setActive,
    machine,
    setMachine,
    rule,
    setRule,
    processType,
    setProcessType,

    // スケジュール設定
    scheduleType,
    setScheduleType,
    days,
    setDays,

    // 定期スケジュール
    from,
    setFrom,
    to,
    setTo,
    interval,
    setInterval,

    // 固定スケジュール
    fixTime,
    setFixTime,

    // PDFレポート
    isPdf,
    setIsPdf,

    // リセット関数
    resetForm
  };
};
